import { SignUpForm } from './SignUpForm';

export default function EmbeddedSignup() {
  return <SignUpForm embedded={true} />;
}
